import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { usePrevious } from 'javascripts/hooks';
import { translate } from 'translations/i18n';
import { Notice, Spinner } from '@companycam/slab-web';

const UploadStatusCard = ({
  pendingUploadCount = 0,
  waitingProcessingCount = 0,
} = {}) => {
  const [showUploadSuccess, setShowUploadSuccess] = useState(false);
  const prevPendingCount = usePrevious(pendingUploadCount);

  useEffect(() => {
    // once we move from some pending to none pending, show success for 2 seconds
    if (prevPendingCount > 0 && pendingUploadCount === 0) {
      setShowUploadSuccess(true);
      setTimeout(() => {
        setShowUploadSuccess(false);
      }, 2000);
    }
  }, [prevPendingCount, pendingUploadCount]);

  if (
    !showUploadSuccess &&
    waitingProcessingCount === 0 &&
    pendingUploadCount === 0
  ) {
    return null;
  }

  let message = null;
  if (showUploadSuccess) {
    message = (
      <span>{translate('assetFeed.uploadStatusCard.successMessage')}</span>
    );
  } else if (pendingUploadCount > 0) {
    message = (
      <span>
        {translate('assetFeed.uploadStatusCard.pendingCount', {
          count: pendingUploadCount,
        })}
      </span>
    );
  } else {
    message = (
      <span>
        {translate('assetFeed.uploadStatusCard.processingCount', {
          count: waitingProcessingCount,
        })}
      </span>
    );
  }

  return (
    showUploadSuccess ? (
      <Notice iconName="check" color="success">
        {message}
      </Notice>
    ) : (
      <Notice contentBefore={<Spinner accessibilityLabel={translate('common.loading')} size="small" />}>
        {message} 
      </Notice>
    )
  );
};

UploadStatusCard.propTypes = {
  pendingUploadCount: PropTypes.number,
  waitingProcessingCount: PropTypes.number,
};

export default UploadStatusCard;
